import { mapGetters } from "vuex";
import numeral from "numeral";
import { currencyByCode } from "@/shared/utils/currencies";

export default {
  computed: {
    ...mapGetters("auth", ["activeCompany"])
  },
  methods: {
    formatCompanyCurrency(amount, format = null, formatTreshold = 1000) {
      const currency = currencyByCode(this.activeCompany.defaultCurrencyCode);
      let formattedAmount;

      if (format && amount > formatTreshold) {
        formattedAmount = numeral(amount).format(format);
      } else {
        formattedAmount = numeral(amount).format("0.00");
      }

      return currency.symbol_native + formattedAmount;
    }
  }
};
